<template>
  <dialog-add
    icon="key"
    :title="$t('edit_credentials')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-tracking-credentials
        :on-cancel="onCancel"
        @saved="$emit('saved')"
        class="elevation-1"
      />
    </template>
  </dialog-add>
</template>

<script>
export default {
  emits: ['saved'],
  methods: {
    onCancel() {
      this.$router.push({
        name: 'tracking-networks-detail',
        params: { id: this.$route.params.id },
        query: this.$route.query,
      });
    },
  },
};
</script>
